import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { CookieSetOptions } from 'universal-cookie'

type Props = {
  component: React.ReactNode;
  redirect: string;
  path: string;
};

/**
 * 未ログイン状態の場合、ログイン画面に遷移する
 */
export function RouteAuthGuard(props: Props): React.ReactElement<Props> {

  const navigate = useNavigate();

  //  Cookieの有効期限:　7日間
  const _7_DayBySeconds = 60 * 60 * 24 * 7;

  //  メールアドレスを保存するcookie
  const [cookieMail, setCookieMail, removeCookieMail] = useCookies(['mailCookie']);
  const mailOptions: CookieSetOptions = {
      path: '/',
      maxAge: _7_DayBySeconds
  }

  //  パスワードを保存するcookie
  const [cookiePass, setCookiePass, removeCookiePass] = useCookies(['passCookie'])
  const passOptions: CookieSetOptions = {
      path: '/login',
      maxAge: _7_DayBySeconds
  }

  useEffect(() => {

    //  cookieにメールアドレス、パスワードが保存されていない場合
    if(cookieMail.mailCookie == null && cookiePass.passCookie == null){

      //  ログイン、パスワードリセット画面以外はログイン画面にリダイレクト
      if(props.path !== '/login' && props.path !== '/reset/password'){
        window.location.replace(props.redirect)
        return;
      }
    }
  },[])

  return <>{props.component}</>;
}
